<template>
  <HeadlineComponent>Broadcast SMS</HeadlineComponent>
  <div class="form-group">
    <label for="text" class="control-label col-sm-2">Text</label>
    <div class="col-sm-10">
      <textarea v-model="message" id="text" class="form-control sms"></textarea>
      <span
        class="characters"
        :style="{ color: message.length > 160 ? 'red' : 'inherit' }"
        >{{ message.length }} / 160 ({{
          Math.ceil(message.length / 160)
        }}
        SMS<span v-if="message.length > 160"
          >, entferne {{ message.length % 160 }} Zeichen um eine SMS
          einzusparen</span
        >)</span
      ><br />
      <span
        >Kosten:
        {{
          Math.round(Math.ceil(message.length / 160) * 0.1071 * 10000) / 10000
        }}
        € / SMS</span
      >
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-10">
      <div class="checkbox">
        <label for="teamleads_only">
          <input type="checkbox" v-model="teamleadsOnly" id="teamleads_only" />
          Nur an Teamleads
        </label>
      </div>
    </div>
  </div>
  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-10">
      <div class="checkbox">
        <label for="crew_with_shifts_only">
          <input
            type="checkbox"
            v-model="crewWithShiftsOnly"
            id="crew_with_shifts_only"
          />
          Nur an Crew mit Schichten (und Teamleads/Admins)
        </label>
      </div>
    </div>
  </div>
  <div class="form-group" v-if="crewWithShiftsOnly">
    <div class="col-sm-offset-2 col-sm-10">
      <select v-model="event_id" id="type" class="form-control">
        <option value="">-- Auswählen --</option>
        <option v-for="event of events" :key="event.id" :value="event.id">
          {{
            $filters.formatDate(event.start_date, "DD.MM.YYYY") +
            " - " +
            event.name
          }}
        </option>
      </select>
    </div>
  </div>
  <div class="form-group" v-if="crewWithShiftsOnly">
    <div class="col-sm-offset-2 col-sm-10">
      <div class="checkbox">
        <label for="crew_with_exakt_required_shifts_only">
          <input
            type="checkbox"
            v-model="crewWithExaktRequiredShiftsOnly"
            id="crew_with_exakt_required_shifts_only"
          />
          Nur an Crew mit exakt sovielen Schichten wie nötig (und
          Teamleads/Admins)
        </label>
      </div>
    </div>
  </div>
  <h2>Kosten</h2>
  <div class="form-group cost col-sm-12">
    Total: <span>{{ totalCostInclUst }}€ (incl. {{ totalUst }}€ USt.)</span>
  </div>
  <div class="form-group">
    <div class="col-sm-10 col-sm-offset-2">
      <LoadingButton class="btn-primary" @click="broadcast()" :loading="loading"
        >Senden</LoadingButton
      >
    </div>
  </div>
</template>

<script>
import { mapActions } from "pinia";
import { useAlertsStore } from "@/stores/alerts.js";
import userService from "@/services/user.service.js";
import LoadingButton from "@/components/LoadingButton.vue";
import HeadlineComponent from "@/components/HeadlineComponent.vue";
import eventService from "@/services/event.service";
import * as Sentry from '@sentry/vue';

export default {
  name: "BroadcastSmsView",
  components: { LoadingButton, HeadlineComponent },
  data() {
    return {
      loading: false,
      message: "",
      teamleadsOnly: false,
      crewWithShiftsOnly: false,
      event_id: "",
      crewWithExaktRequiredShiftsOnly: false,
      user: [],
      events: [],
    };
  },
  async beforeRouteEnter(to, from, next) {
    let user = [];
    let events = [];
    try {
      let response = await userService.index(true);
      user = response.data;
      response = await eventService.index(true);
      events = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        useAlertsStore().add(
          "danger",
          "Es ist was unerwartetes schief gegangen.."
        );
        window.scrollTo(0, 0);
      }
    }
    let event_id = to.query.event_id ? to.query.event_id : "";
    let crewWithShiftsOnly = to.query.event_id ? true : false;
    next((vm) => {
      vm.user = user;
      vm.events = events;
      vm.event_id = event_id;
      vm.crewWithShiftsOnly = crewWithShiftsOnly;
    });
  },
  methods: {
    ...mapActions(useAlertsStore, { addAlert: "add" }),
    async broadcast() {
      this.loading = true;
      try {
        let data = {
          message: this.message,
          teamleads_only: this.teamleadsOnly,
          crew_with_shifts_only: this.crewWithShiftsOnly,
          crew_with_exakt_required_shifts_only:
            this.crewWithExaktRequiredShiftsOnly,
        };
        if (this.event_id) {
          data.event_id = this.event_id;
        }
        let response = await userService.broadcast(data);
        this.addAlert("success", response.data.message);
        this.message = "";
        this.teamleadsOnly = false;
        this.crewWithOneShiftOnly = false;
        this.crewWithExaktRequiredShiftsOnly = false;
        this.loading = false;
      } catch (e) {
        if (e) {
          Sentry.captureException(e);
          this.addAlert("danger", "Es ist was unerwartetes schief gegangen..");
          window.scrollTo(0, 0);
        }
        this.loading = false;
      }
    },
  },
  computed: {
    totalCost() {
      var event_id = this.event_id;
      const sms = Math.ceil(this.message.length / 160) * 0.11;
      let price = 0;
      if (!this.teamleadsOnly && !this.crewWithShiftsOnly) {
        price = this.user.length * sms;
      } else if (this.teamleadsOnly) {
        const tls = this.user.filter((u) => u.role > 2);
        price = tls.length * sms;
      } else if (this.event_id) {
        if (this.crewWithShiftsOnly) {
          var tls = this.user.filter(
            (u) =>
              u.role > 2 ||
              (u.shifts &&
                u.shifts.filter((s) => s.event_id == event_id).length > 0)
          );
          if (this.crewWithExaktRequiredShiftsOnly) {
            var required_shifts = 0;
            for (var i = 0; i < this.events.length; i++) {
              if (this.events[i].id == event_id) {
                required_shifts = this.events[i].min_required_shifts;
                break;
              }
            }
            tls = this.user.filter(
              (u) =>
                u.role > 2 ||
                (u.shifts &&
                  u.shifts.filter((s) => s.event_id == event_id).length ==
                    required_shifts)
            );
          }
          price = tls.length * sms;
        }
      }
      return Math.round(price * 10000) / 10000;
    },
    totalUst() {
      return Math.round(this.totalCost * 0.19 * 10000) / 10000;
    },
    totalCostInclUst() {
      return Math.round((this.totalCost + this.totalUst) * 10000) / 10000;
    },
  },
  watch: {
    teamleadsOnly() {
      if (this.teamleadsOnly) {
        this.crewWithExaktRequiredShiftsOnly = false;
        this.crewWithShiftsOnly = false;
      }
    },
    crewWithShiftsOnly() {
      if (this.crewWithShiftsOnly) {
        this.teamleadsOnly = false;
      } else {
        this.crewWithExaktRequiredShiftsOnly = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.sms {
  height: 140px;
}

.cost {
  font-size: large;

  span {
    font-weight: bold;
  }
}
</style>
